import React from "react";
import Header from "@configuratorware/configurator-frontendgui/App/Shared/Containers/Header";
import HeaderComponent from "../../Components/Header/Header";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import { useSelector } from "react-redux";

const CustomHeaderContainer = (props) => {
  const selectedLevel = useSelector(
    (state) => state.configurator.configuration.customdata.level_visibility
  );
  const itemTitle = useSelector(
    (state) => state.configurator.configuration.item.title
  );

  const getTitleWithLevel = () => {
    if (selectedLevel) {
      return t("headerTitle.level" + selectedLevel.toString()) + " | ";
    } else {
      return "";
    }
  };
  return (
    <Header
      Component={HeaderComponent}
      title={getTitleWithLevel() + itemTitle}
      {...props}
    />
  );
};

export default CustomHeaderContainer;
